import { render, staticRenderFns } from "./updatacompany.vue?vue&type=template&id=49f1f127&scoped=true&"
import script from "./updatacompany.vue?vue&type=script&lang=js&"
export * from "./updatacompany.vue?vue&type=script&lang=js&"
import style0 from "./updatacompany.vue?vue&type=style&index=0&id=49f1f127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f1f127",
  null
  
)

export default component.exports